import '@vaadin/icon';
import '@vaadin/vaadin-lumo-styles/vaadin-iconset.js';
import '@vaadin/icons';

import { Component, html, LitElement, property, query } from '@rxdi/lit-html';

/**
 * @customElement rx-icon
 */
@Component({
  selector: 'rx-icon',
  template(this: IconComponent) {
    return html`
      <vaadin-icon .icon=${this.icon}>
        <slot></slot>
      </vaadin-icon>
    `;
  },
})
export class IconComponent extends LitElement {
  @property({ type: String })
  icon: string;

  @query('slot')
  iconSlot: HTMLSlotElement;

  OnUpdate() {
    const [icon] = this.iconSlot.assignedNodes();
    this.icon = icon?.nodeValue ?? this.icon;
  }
}
